import { Camera } from 'types/camera';
import { Stream } from 'types/stream';

export function getVideoSourceDisplayInfo(videoSource: Camera | Stream) {
  if ('conn_type' in videoSource) {
    const camera = videoSource;

    if (camera.ip_ext) {
      return camera.uri ?? camera.ip_ext;
    }

    return camera.ip_local;
  }

  const stream = videoSource as Stream;

  switch (stream.stream_type) {
    case 'file':
      return undefined;
    default:
      return stream.uri;
  }
}
